import { HealthData } from '../Enums/HealthData.enum';
import { Table } from '../Enums/Table.enum';
import { BabyLatamMonitoring } from '../../Questionnaire/Enums/BabyLatamMonitoring.enum';

export const TABLE_DATASET = {
	[Table.MULTIPLE]: {
		title: 'Super tabulka',
		keys: [
			HealthData.BLOOD_GLUCOSE,
			HealthData.WEIGHT,
			HealthData.HEIGHT,
			HealthData.WAISTLINE,
			HealthData.STEP_COUNT,
			HealthData.BREATHING_RATE,
			HealthData.OXYGEN_SATURATION,
			HealthData.SLEEP,
			HealthData.HEMOGLOBIN,
			HealthData.HEMOGLOBIN_A1C,
			HealthData.STRESS_LEVEL,
			HealthData.ACTIVE_ENERGY,
			HealthData.DISTANCE_WALKING_RUNNING,
			HealthData.WORKOUT,
		],
	},
	[Table.QUESTIONNAIRE_RESULTS_LATAM_BABY]: {
		title: '',
		keys: [
			BabyLatamMonitoring.VAGINAL_BLEEDING,
			BabyLatamMonitoring.TEMPERATURE,
			BabyLatamMonitoring.WEIGHT,
			BabyLatamMonitoring.URINARY_TRACT_INFECTION,
			BabyLatamMonitoring.VAGINAL_INFECTION,
			BabyLatamMonitoring.VOMITING,
			BabyLatamMonitoring.DIARRHOEA,
			BabyLatamMonitoring.SWELLING,
			BabyLatamMonitoring.MEDICAMENTS,
			BabyLatamMonitoring.BLOOD_PRESSURE,
			BabyLatamMonitoring.GLYCEMIA,
			BabyLatamMonitoring.AMNIOTIC_FLUID_LEAK,
			BabyLatamMonitoring.HYPERTENSION_SYMPTOMS,
			BabyLatamMonitoring.BREAST_SELF_ASSESSMENT,
			BabyLatamMonitoring.UTERINE_CONTRACTIONS,
			BabyLatamMonitoring.COMBINED,
		],
	},
};
